import { render, staticRenderFns } from "./BatteryProductSummary.vue?vue&type=template&id=4aa82e8c"
import script from "./BatteryProductSummary.vue?vue&type=script&lang=ts"
export * from "./BatteryProductSummary.vue?vue&type=script&lang=ts"
import style0 from "./BatteryProductSummary.vue?vue&type=style&index=0&id=4aa82e8c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports